import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 70,
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    background: "#fff",
    paddingInline: 28,
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow:
      " 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
  },
  editIcon: {
    border: `1px solid #ffffff`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ffffff",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
    "& .MuiButton-root": {
      color: "#ffffff",
    },
  },
  dispatcherbutton:{
    background: "#0a0a0aff !important",
  },
  headerleftwrap:{
    display: "flex",
  },
  headerrightwrap:{
    display: "flex",
    justifyContent: "right",
  },
  welcomeContiner: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: "cover",
    cursor: "pointer",
  },
  headernav:{

  },
  avatarContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  bellnotification:{
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    margin:"0px 17px",
    "& .MuiIconButton-root": {
        border: "1px solid"
    }
  },
  notificationpanel:{
    
  },
  notificationiconbutton:{

  },
  notifycount:{
    "& .MuiBadge-badge": {
        color:"#fff"
    }
  },
  menu: {
    "& .MuiMenu-list": {
      paddingTop: 16,
      paddingBottom: 16,
      background: "#fff",
      backdropFilter: "blur(30px)",
    },
    "& .MuiButtonBase-root": {
      paddingRight: 40,
    },
  },
  menuItem: {
    gap: 8,
  },
  menuLabels: {
    paddingInline: 12,
    dispay: "flex",
    gap: 8,
    alignItems: "center",
  },
}));

export default useStyles;
